const style: any = (): any => {
	return {
		toggleButtonGroup: {
			display: "inline-block",
			borderRadius: 2,
			border: "1px solid #d0d5da",
		},
		selectedButton: {
			borderRadius: 2,
			border: "1px solid #3a91e8 !important",
			boxShadow: "0px 1px 4px 0px rgba(21, 118, 214, 0.15)",
			backgroundColor: "#f0f8ff !important",
		},
		toggleButton: {
			padding: "7px 17px",
			marginLeft: "0px !important",
			height: 36,
			borderRadius: 0,
			border: 0,
			backgroundColor: "#FFFF",
			color: "#242c34 !important",
			fontSize: 14,
			textTransform: "none" as const,
			fontWeight: "normal" as const,

		},
		toggleButtonLifecycle: {
			marginLeft: "0px !important",
			padding: "7px 16.4px",
			borderRadius: 0,
			backgroundColor: "#FFFF",
			border: 0,
			height: 36,
			fontSize: 14,
			color: "#242c34 !important",
			fontWeight: "medium" as const,
			textTransform: "none" as const,
		},
		
	};
};

export default style;